import { http, httpV2 } from "@/api/index";

/**
* @summary Busca o log de modificações de diagnóstico e tendências.
* @param {monitoringElementId, dateTimeParams}
* @returns {Object} JSON com as modificações nos controladores baseado no intervalo de tempo.
*/

const GetAuditLogData = function(monitoringElementId, auditType)
{
	return http.get(`/AuditLoggings/${monitoringElementId}
		?auditType=${auditType}`);
};

/**
* @summary Busca o log de modificações de diagnóstico e tendências.
* @param {monitoringElementId, dateTimeParams}
* @returns {Object} JSON com as modificações nos controladores baseado no intervalo de tempo.
*/

const GetFilteredAuditLogData = function(monitoringElementId, dateTimeParams, auditType)
{
	return http.get(`/AuditLoggings
		?assetMonitoringElementId=${monitoringElementId}
		&auditType=${auditType}
		&startDateTime=${dateTimeParams.startDateTime}
		&endDateTime=${dateTimeParams.endDateTime}`);
};

/**
* @summary Obtém logs de auditoria de notificações de limites de tendências de uma turbina.
* @param {monitoringElementId, dateTimeParams}
* @returns {Object} JSON com os logs de de auditoria de notificações de limites de tendências.
*/
const GetAuditLoggingsNotificationData = function(monitoringElementId, dateTimeParams)
{
	return httpV2.get(`/AuditLoggingsNotification
	?assetMonitoringElementId=${monitoringElementId}
	&startDateTime=${dateTimeParams.startDateTime}
	&endDateTime=${dateTimeParams.endDateTime}`);
};

export default
{
	GetAuditLogData, GetFilteredAuditLogData, GetAuditLoggingsNotificationData
};